<template>
  <div>
    <div style="height: 500px; overflow: scroll">
      <modal :width="width">
        <div slot="header">
          <button type="button" class="close" @click="CloseModal">
            &times;
          </button>
        </div>
        <div slot="body">
          <div v-if="!loading">
            <center class="loading-medium" v-if="loading">
              <loading></loading>
            </center>
          </div>
          <div v-if="!loading">
            <div
              v-if="
                DownloadingErrorMessage != null && DownloadingErrorMessage != ''
              "
            >
              <div class="alert alert-danger text-center">
                <strong>{{ DownloadingErrorMessage }}</strong>
              </div>
            </div>
            <div v-if="View_message != null && View_message != ''">
              <div class="alert alert-danger text-center">
                <strong>{{ View_message }}</strong>
              </div>
            </div>
            <div v-if="errorMessage != null && errorMessage != ''">
              <div class="alert alert-danger text-center">
                <strong>{{ errorMessage }}</strong>
              </div>
            </div>
            <div v-if="Active == 'SaleConfirmation'">
              <saleconfirmation></saleconfirmation>
            </div>
            <div v-if="Active == 'HoldingCertificate'">
              <holdingcertificate />
            </div>
            <div v-if="Active == 'SaleConfirmationToAston'">
              <saleconfirmationtoaston />
            </div>
            <div v-if="Active == 'PurchaseConfirmation'">
              <purchaseconfirmation />
            </div>
            <div
              v-if="Active == 'SaleDocuments'"
              style="height: 1300px; overflow-x: scroll"
            >
              <saledocuments />
              <br />
              <settlementinstructions />
              <br />
              <obligationtransfer />
              <br />
              <approvalofsettlementinstructions />
              <br />
              <deliveryinstruction />
            </div>
            <div v-if="Active == 'TransferOfOwnership'">
              <transferofownership />
            </div>
            <!-- <div v-if="Active == 'ContractOfSale'">
              <contractofsale />
            </div>
           

            <div v-if="Active == 'ContractOfPurchase'">
              <contractofpurchase />
            </div>

            <div v-if="Active == 'SellerAcceptance'">
              <selleracceptance />
            </div>
            <div v-if="Active == 'noticeofdelivery'">
              <noticeofdelivery />
            </div>

            <div v-if="Active == 'SellerRequest'">
              <sellerrequest />
            </div> -->
          </div>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-xs-5"></div>
            <div class="col-xs-2">
              <loading v-if="Downloading" style="padding-right: 10px"></loading>
            </div>
            <div class="col-xs-5"></div>
          </div>
          <br />

          <div class="row" style="text-align: left; padding-left: 5%">
            <div
              class="col-xs-3"
              v-if="
                (RoleId == 4 || RoleId == 5) &&
                Request &&
                (Request.Sell == null || Request.Sell == false)
              "
            >
              <button class="btn btn-info" @click="Edit">Edit Request</button>
            </div>
            <div class="col-xs-3" v-if="Active == 'SaleConfirmation'">
              <button class="btn btn-success" @click="SaleConfirmation">
                Download Confirmation of Sale
              </button>
            </div>
            <div class="col-xs-3" v-if="Active == 'HoldingCertificate'">
              <button class="btn btn-success" @click="HoldingCertificate">
                Download Holding Certificate
              </button>
            </div>
            <div class="col-xs-3" v-if="Active == 'SaleConfirmationToAston'">
              <button class="btn btn-success" @click="SaleConfirmationToAston">
                Download Sale Confirmation To Aston
              </button>
            </div>
            <div class="col-xs-3" v-if="Active == 'PurchaseConfirmation'">
              <button class="btn btn-success" @click="PurchaseConfirmation">
                Download Purchase Confirmation
              </button>
            </div>
            <div class="col-xs-3" v-if="Active == 'SaleDocuments'">
              <button class="btn btn-success" @click="SaleDocuments">
                Download Sale Documents
              </button>
            </div>
            <div class="col-xs-3" v-if="Active == 'TransferOfOwnership'">
              <button class="btn btn-success" @click="TransferOfOwnership">
                Download Transfer Of Ownership
              </button>
            </div>
            <div class="col-xs-1"></div>
            <div class="col-xs-3" v-if="RoleId == 5&& !Request.Sell">
              <button class="btn btn-light" @click="PhysicalDelivery">
                Physical Delivery
              </button>
            </div>
            <!--<div class="col-xs-3" v-if="Active == 'ContractOfPurchase'">
              <button class="btn btn-success" @click="ContractOfPurchase">
                Download Contract Of Purchase
              </button>
            </div> -->
            <!-- <div
              class="col-xs-3"
              v-if="
                Active == 'PurchaseAcceptance' &&
                  Request &&
                  Request.Accepted == true
              "
            >
              <button
                class="btn btn-success"
                @click="PurchaseAcceptance"
              >Download Purchase Accptance</button>
            </div>-->
            <!-- <div class="col-xs-3" v-if="Active == 'CommodityCertificate'">
              <button class="btn btn-success" @click="CommodityCertificate">
                Download Commodity Certificate
              </button>
            </div>
            <div
              class="col-xs-3"
              v-if="
                Active == 'PurchaseAcceptance' &&
                Request &&
                Request.Accepted == true
              "
            >
              <button class="btn btn-success" @click="PurchaseAcceptance">
                Download Purchase Accptance
              </button>
            </div>

            <div
              class="col-xs-3"
              v-if="
                Active == 'PurchaseOffer' && Request && Request.Sell == true
              "
            >
              <button class="btn btn-success" @click="PurchaserOffer">
                Download Purchaser's Offer
              </button>
            </div>

            <div
              class="col-xs-3"
              v-if="
                Active == 'SellerRequest' && Request && Request.Sell == true
              "
            >
              <button class="btn btn-success" @click="SellerRequest">
                Download Seller's Request
              </button>
            </div>
            <div
              class="col-xs-3"
              v-if="
                Active == 'SellerAcceptance' &&
                Request &&
                Request.SellAccepted == true
              "
            >
              <button class="btn btn-success" @click="SellerAcceptance">
                Download Seller's Acceptance
              </button>
            </div>
            <div
              class="col-xs-3"
              v-if="
                Active == 'noticeofdelivery' &&
                Request &&
                Request.SellAccepted == true
              "
            >
              <button class="btn btn-success" @click="NoticeOfDelivery">
                Download Notice of Sale
              </button>
            </div> -->
          </div>
          <br />
          <div class="row" style="text-align: left; padding-left: 5%">
            <div class="col-xs-3">
              <button
                class="btn btn-primary"
                @click="ChangeActive('SaleConfirmation')"
              >
                Confirmation Of Sale
              </button>
            </div>
            <div class="col-xs-3">
              <button
                class="btn btn-primary"
                @click="ChangeActive('HoldingCertificate')"
              >
                Holding Certificate
              </button>
            </div>
            <div class="col-xs-2" v-if="Request.TransferOfOwner">
              <button
                class="btn btn-primary"
                @click="ChangeActive('TransferOfOwnership')"
              >
                Transfer Of Ownership
              </button>
            </div>
            <div
              class="col-xs-3"
              :style="Request.TransferOfOwner ? 'margin-left: 55px' : ''"
              v-if="Request.Sell"
            >
              <button
                class="btn btn-primary"
                @click="ChangeActive('SaleConfirmationToAston')"
              >
                Sale Confirmation To Aston
              </button>
            </div>
          </div>
          <br />
          <br />
          <div class="row" style="text-align: left; padding-left: 5%">
            <div class="col-xs-3" v-if="Request.Sell">
              <button
                class="btn btn-primary"
                @click="ChangeActive('PurchaseConfirmation')"
              >
                Purchase Confirmation
              </button>
            </div>
            <div class="col-xs-3" v-if="Request.Sell">
              <button
                class="btn btn-primary"
                @click="ChangeActive('SaleDocuments')"
              >
                Sale Documents
              </button>
            </div>

            <!--  <div class="col-xs-3">
              <button
                v-if="Request && Request.Sell == true"
                class="btn btn-primary"
                @click="ChangeActive('SellerRequest')"
              >
                Seller's Request
              </button>
            </div>
            <div class="col-xs-3">
              <button
                v-if="Request && Request.Sell == true"
                class="btn btn-primary"
                @click="ChangeActive('PurchaseOffer')"
              >
                Purchaser's Offer
              </button>
            </div>
            <div class="col-xs-3">
              <button
                class="btn btn-primary"
                v-if="Request && Request.Sell == true"
                @click="ChangeActive('ContractOfPurchase')"
              >
                Contract Of Purchase
              </button>
            </div> -->
          </div>
          <br />
          <br />
          <div class="row" style="text-align: left; padding-left: 5%">
            <!-- <div class="col-xs-3">
              <button
                v-if="Request && Request.SellAccepted == true"
                class="btn btn-primary"
                @click="ChangeActive('SellerAcceptance')"
              >
                Seller's Acceptance
              </button>
            </div>
            <div class="col-xs-3">
              <button
                v-if="Request && Request.SellAccepted == true"
                class="btn btn-primary"
                @click="ChangeActive('noticeofdelivery')"
              >
                Notice Of Sale
              </button>
            </div> -->
            <div class="col-xs-3"></div>
            <div class="col-xs-3"></div>
          </div>
          <br />
          <div class="row">
            <div class="col-xs-3"></div>
            <div class="col-xs-2"></div>
            <div class="col-xs-3">
              <button
                class="btn btn-danger"
                v-if="Request && Request.Sell == true && RoleId == 1"
                @click="DeleteConfirm = true"
              >
                Cancel Transaction
              </button>
              <button
                class="btn btn-success"
                v-if="Request && !Request.Sell && (RoleId == 4 || RoleId == 5)"
                @click="OpenTransferOfOwnerModal"
              >
                Transafer of Owner
              </button>
            </div>
            <div class="col-xs-2">
              <button class="btn btn-info" @click="DownloadAll">
                Download All
              </button>
            </div>
            <div class="col-xs-1">
              <button class="btn btn-warning" @click="CloseModal">Close</button>
            </div>
          </div>
        </div>
      </modal>
      <modal v-if="DeleteConfirm">
        <div slot="header">
          <h3>Delete Transaction</h3>
        </div>
        <div slot="body">
          <div>
            <div v-if="success_message != '' && success_message != null">
              <div class="alert alert-success text-center">
                <strong>{{ success_message }}</strong>
              </div>
            </div>
            <div v-if="CONFIRMERROR != null && CONFIRMERROR != ''">
              <div class="alert alert-danger text-center">
                <strong>{{ CONFIRMERROR }}</strong>
              </div>
            </div>
            <input
              type="text"
              class="form-control"
              v-model="CancelComments"
              autocomplete="off"
              name="CancelComments"
              v-validate="'valid_FirstChar|max:250'"
              placeholder="Cancel Comments"
              data-vv-as="Cancel Comments"
              maxlength="250"
              data-vv-validate-on="blur"
            />
            <span class="text-danger">{{
              errors.first("CancelComments")
            }}</span>
          </div>
        </div>
        <div slot="footer">
          <loading v-if="CONFIRMLOADING"></loading>
          <button class="btn btn-danger" @click="Delete">Delete</button>
          <button class="btn btn-warning" @click="GoBack">Back</button>
        </div>
      </modal>
      <modal v-if="ShowTransferOfOwner">
        <div slot="header">
          <h3>Transfer Of Owner</h3>
        </div>
        <div slot="body">
          <div>
            <div v-if="success_message != '' && success_message != null">
              <div class="alert alert-success text-center">
                <strong>{{ success_message }}</strong>
              </div>
            </div>
            <div
              v-if="
                request_error_message != null && request_error_message != ''
              "
            >
              <div class="alert alert-danger text-center">
                <strong>{{ request_error_message }}</strong>
              </div>
            </div>
            <div v-if="CONFIRMERROR != null && CONFIRMERROR != ''">
              <div class="alert alert-danger text-center">
                <strong>{{ CONFIRMERROR }}</strong>
              </div>
            </div>
            <suggestions
              v-model="TransferOfOwner"
              :options="options"
              :onInputChange="Autocomplete"
            />

            <!-- <input
              type="text"
              class="form-control"
              v-model="TransferOfOwner"
              autocomplete="off"
              name="TransferOwner"
              v-validate="'valid_FirstChar|max:250'"
              placeholder="Ex: Alinma bank"
              data-vv-as="Transfer Owner"
              maxlength="250"
              data-vv-validate-on="blur"
            /> -->
            <span class="text-danger">{{ errors.first("TransferOwner") }}</span>
          </div>
        </div>
        <div slot="footer">
          <loading v-if="CONFIRMLOADING"></loading>
          <button
            class="btn btn-danger"
            v-if="isExistTransferOfOwner"
            @click="RemoveOwnerConfirmation = true"
          >
            Remove Transfer Of Owner
          </button>

          <button class="btn btn-primary" @click="UpdateOwner">
            Save Changes
          </button>
          <button class="btn btn-warning" @click="GoBack">Back</button>
        </div>
      </modal>
      <modal v-if="RemoveOwnerConfirmation">
        <div slot="header">
          <h3>Remove Ownership</h3>
        </div>
        <div slot="body">are you sure you want to remove Ownership?</div>
        <div slot="footer">
          <button class="btn btn-danger" @click="RemoveOwner">
            Yes, Remove
          </button>
          <button
            class="btn btn-warning"
            @click="RemoveOwnerConfirmation = false"
          >
            Back
          </button>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import saleconfirmation from "../Docs/SaleConfirmation";
import holdingcertificate from "../Docs/HoldingCertificate";
import saleconfirmationtoaston from "../Docs/SaleConfirmationToAston";
import purchaseconfirmation from "../Docs/PurchaseConfirmation";
import saledocuments from "../Docs/SaleDocuments";
import settlementinstructions from "../Docs/SettlementInstructions";
import obligationtransfer from "../Docs/ObligationTransfer";
import approvalofsettlementinstructions from "../Docs/ApprovalOfSettlementInstructions";
import deliveryinstruction from "../Docs/DeliveryInstructions";
import transferofownership from "../Docs/TransferOfOwnership";
// import commoditysertificate from "../Docs/CommodityCertificate";
// import contractofsale from "../Docs/ContractOfSale";
// import sellerrequest from "../Docs/SellerRequest";
// import selleracceptance from "../Docs/SellerAcceptance";
// import purchaseoffer from "../Docs/PurchaseOffer";
// import contractofpurchase from "../Docs/ContractOfPurchase";
// import noticeofdelivery from "../Docs/NoticeOfDelivery";
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";
import suggestions from "v-suggestions";
//import PurchaseConfirmation from "../Docs/PurchaseConfirmation.vue";

export default {
  data() {
    return {
      View_message: null,
      Active: "SaleConfirmation",
      width: 950,
      DeleteConfirm: false,
      CancelComments: "",
      options: {
        inputClass: "form-control",
        placeholder: "Ex: Alinma bank",
        maxlength: 250,
      },
      success_message: null,
      ShowTransferOfOwner: false,
      TransferOfOwnerSuccess: null,
      TransferOfOwner: "",
      isExistTransferOfOwner: false,
      request_error_message: null,
      RemoveOwnerConfirmation: false,
      ListTransferOfOwner: [],
    };
  },
  props: {
    RequestId: Number,
  },
  components: {
    saleconfirmation,
    holdingcertificate,
    saleconfirmationtoaston,
    purchaseconfirmation,
    saledocuments,
    settlementinstructions,
    obligationtransfer,
    approvalofsettlementinstructions,
    deliveryinstruction,
    transferofownership,
    suggestions,
  },
  methods: {
    PhysicalDelivery() {
      var Url = "/PhysicalDelivery?RequestId="+ (this.RequestId==null?0:this.RequestId);
      var vm = this;
      this.$store
        .dispatch(ACTIONS.PHYSICAL_DELIVERY, Url)
        .then((res) => {
          if (res && res.status == 200) {
            alert("Success update physical delivery");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    Autocomplete(query) {
      this.$validator.errors.remove("TransferOwner");
      if (query == null || query.trim().length === 0) {
        this.TransferOfOwner = "";
        this.$validator.errors.add({
          field: "TransferOwner",
          msg: "The Transfer Of Owner field is required.",
        });
        return null;
      }
      this.TransferOfOwner = query;
      var re = this.TransferOfOwner.charAt(0);
      if (re == "@" || re == "+" || re == "-" || re == "=") {
        this.$validator.errors.add({
          field: "TransferOwner",
          msg: "First character shuold not be '@','-',+','='",
        });
        return null;
      }
      if (query.length > 250) {
        this.$validator.errors.add({
          field: "TransferOwner",
          msg: "The Client Name field should be maximum 250 character length",
        });
        return;
      }
      if (
        this.ListTransferOfOwner == null ||
        this.ListTransferOfOwner.length == 0
      ) {
        return null;
      }
      return this.ListTransferOfOwner.filter((name) => {
        return name.toLowerCase().includes(query.toLowerCase());
      });
    },
    OpenTransferOfOwnerModal() {
      this.ShowTransferOfOwner = true;
      this.TransferOfOwner = this.Request.TransferOwner;
      this.isExistTransferOfOwner = this.Request.TransferOfOwner;
    },
    Edit() {
      this.$emit("Edit");
    },
    RemoveOwner() {
      this.RemoveOwnerConfirmation = false;
      var vm = this;
      var Url =
        "RemoveTransferOfOwner?RequestId=" +
        (this.RequestId == null ? 0 : this.RequestId);
      this.$store
        .dispatch(ACTIONS.REMOVE_OWNER, Url)
        .then((res) => {
          var { data } = res;
          if (data && data.StatusCode == 200) {
            vm.TransferOfOwner = "";
            vm.success_message = "Transaction updated successfully";
            setTimeout(function () {
              vm.success_message = null;
              vm.ShowTransferOfOwner = false;
              vm.GoBack();
              vm.getData();
            }, 2500);
          } else if (
            data &&
            (data.StatusCode == 500 ||
              data.StatusCode == 403 ||
              data.StatusCode == 2 ||
              data.StatusCode == 450 ||
              data.StatusCode == 429 ||
              data.StatusCode == 1 ||
              data.StatusCode == 406 ||
              data.StatusCode == 0)
          ) {
          } else {
            vm.ShowTransferOfOwner = false;
            vm.TransferOfOwner = "";
            console.log(res);
          }
        })
        .catch((err) => {
          vm.ShowTransferOfOwner = false;
          vm.TransferOfOwner = "";
          console.log(err);
        });
    },
    UpdateOwner() {
      var vm = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          var params = new URLSearchParams();
          params.append("RequestId", vm.RequestId == null ? 0 : vm.RequestId);
          params.append("TransferOwner", vm.TransferOfOwner);
          params.append("URL", "UpdateOwner");
          this.$store
            .dispatch(ACTIONS.CANCEL_COMPLETED_TRANSACTION, params)
            .then((res) => {
              var { data } = res;
              if (data && data.StatusCode == 200) {
                vm.TransferOfOwner = "";
                vm.success_message = "Transaction updated successfully";
                setTimeout(function () {
                  vm.ShowTransferOfOwner = false;
                  vm.success_message = null;
                  vm.GoBack();
                  vm.getData();
                }, 2500);
              } else if (data && data.StatusCode == 450) {
                var { ResponseData } = data;
                if (ResponseData) {
                  for (var prop in ResponseData) {
                    vm.$validator.errors.add({
                      field: prop,
                      msg: ResponseData[prop],
                    });
                  }
                }
              } else if (
                data &&
                (data.StatusCode == 500 ||
                  data.StatusCode == 403 ||
                  data.StatusCode == 2 ||
                  data.StatusCode == 429 ||
                  data.StatusCode == 1 ||
                  data.StatusCode == 406 ||
                  data.StatusCode == 0)
              ) {
              } else {
                vm.ShowTransferOfOwner = false;
                vm.TransferOfOwner = "";
                console.log(res);
              }
            })
            .catch((err) => {
              vm.ShowTransferOfOwner = false;
              vm.TransferOfOwner = "";
              console.log(err);
            });
        } else {
          vm.request_error_message = "Please  provide Correct details";
          setTimeout(function () {
            vm.request_error_message = null;
          }, 1500);
        }
      });
    },
    ChangeActive(active) {
      this.Active = active;
    },

    SaveFile(data, fileName = "PDF") {
      var _name = null;
      //if (fileName) {
      _name = fileName;
      //} else {
      if (this.Request && this.Request.RefNo) {
        _name += this.Request.RefNo == null ? "" : this.Request.RefNo;
        while (_name.includes("/")) {
          _name = _name.replace("/", "_");
        }
        //}
      }
      _name = _name == null ? "PDF.pdf" : _name + ".pdf";
      if (window.navigator && window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(new Blob([data]), _name);
      } else {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", _name);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    },
    GoBack() {
      this.CancelComments = null;
      this.request_error_message = null;
      this.TransferOwner = null;
      this.isExistTransferOfOwner = false;
      this.$validator.errors.remove("CancelComments");
      this.$validator.errors.remove("TransferOfOwner");
      var vm = this;
      this.success_message = "";
      this.$store.commit(ACTIONS.CANCEL_COMPLETED_TRANSACTION_SUCCESS);
      setTimeout(function () {
        vm.DeleteConfirm = false;
        vm.ShowTransferOfOwner = false;
      }, 100);
    },
    Download(Query, filename) {
      var vm = this;
      this.$store
        .dispatch(ACTIONS.DOWNLOAD_DOCUMENT, Query)
        .then((res) => {
          if (res && res.status == 200) {
            vm.SaveFile(res.data, filename);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    SaleConfirmation() {
      if (this.RequestId == null || this.RequestId == 0) {
        return;
      }
      var Url = "/SaleConfirmation?RequestId=" + this.RequestId;
      this.Download(Url, "Confirmation_Of_Sale_");
    },
    HoldingCertificate() {
      if (this.RequestId == null || this.RequestId == 0) {
        return;
      }
      var Url = "/HoldingCertificate?RequestId=" + this.RequestId;
      this.Download(Url, "Holding_Certificate_");
    },
    SaleConfirmationToAston() {
      if (this.RequestId == null || this.RequestId == 0) {
        return;
      }
      var Url = "/SaleConfirmationToAston?RequestId=" + this.RequestId;
      this.Download(Url, "Sale_Confirmation_To_Aston_");
    },
    PurchaseConfirmation() {
      if (this.RequestId == null || this.RequestId == 0) {
        return;
      }
      var Url = "/PurchaseConfirmation?RequestId=" + this.RequestId;
      this.Download(Url, "Purchase_Confirmation_");
    },
    SaleDocuments() {
      if (this.RequestId == null || this.RequestId == 0) {
        return;
      }
      var Url = "/SaleDocuments?RequestId=" + this.RequestId;
      this.Download(Url, "Sale_Documents_");
    },
    TransferOfOwnership() {
      if (this.RequestId == null || this.RequestId == 0) {
        return;
      }
      var Url = "/TransferOfOwnership?RequestId=" + this.RequestId;
      this.Download(Url, "Transfer_Of_Ownership_");
    },
    // PurchaseAcceptance() {
    //   if (this.RequestId == null || this.RequestId == 0) {
    //     return;
    //   }
    //   var Url = "/PurchaseAcceptance?RequestId=" + this.RequestId;
    //   this.Download(Url, "Purchase_Acceptance_");
    // },
    // CommodityCertificate() {
    //   if (this.RequestId == null || this.RequestId == 0) {
    //     return;
    //   }
    //   var Url = "/CommodityCertificate?RequestId=" + this.RequestId;
    //   this.Download(Url, "Commodity_Certificate_");
    // },
    // SellerRequest() {
    //   if (this.RequestId == null || this.RequestId == 0) {
    //     return;
    //   }
    //   var Url = "/SellerRequest?RequestId=" + this.RequestId;
    //   this.Download(Url, "Seller_Request_");
    // },
    // PurchaserOffer() {
    //   if (this.RequestId == null || this.RequestId == 0) {
    //     return;
    //   }
    //   var Url = "/PurchaserOffer?RequestId=" + this.RequestId;
    //   this.Download(Url, "Purchaser_Offer_");
    // },
    // SellerAcceptance() {
    //   if (this.RequestId == null || this.RequestId == 0) {
    //     return;
    //   }
    //   var Url = "/SellerAcceptance?RequestId=" + this.RequestId;
    //   this.Download(Url, "Seller_Acceptance_");
    // },
    // NoticeOfDelivery() {
    //   if (this.RequestId == null || this.RequestId == 0) {
    //     return;
    //   }
    //   var Url = "/NoticeOfDelivery?RequestId=" + this.RequestId;
    //   this.Download(Url, "Notice_Of_Delivery_");
    // },
    DownloadAll() {
      if (this.RequestId == null || this.RequestId == 0) {
        return;
      }
      var Url = "/DownloadAll?RequestId=" + this.RequestId;
      this.Download(Url, "Documents_All_");
    },

    CloseModal() {
      this.$store.commit(ACTIONS.DOWNLOAD_DOCUMENT_SUCCESS);
      this.$emit("Close");
    },
    getData() {
      var Url = "?id=" + (this.RequestId == null ? 0 : this.RequestId);
      var vm = this;
      this.$store
        .dispatch(ACTIONS.BUY_REQUEST_VIEW, Url)
        .then((res) => {
          var { data } = res;
          if (data && data.StatusCode == 200) {
            vm.ListTransferOfOwner = data.ResponseData.TransferOwner;

            // /vm.Active = "SellerOffer";
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    Delete() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$validator.errors.remove("CancelComments");
          var params = new URLSearchParams();
          params.append("RequestId", this.RequestId);
          if (this.CancelComments != null && this.CancelComments != "") {
            params.append("CancelComments", this.CancelComments);
          }
          // if (this.Commodity != null && this.Commodity != 0) {
          //   params.append("Commodityid", this.Commodity);
          // }
          var vm = this;
          this.$store
            .dispatch(ACTIONS.CANCEL_COMPLETED_TRANSACTION, params)
            .then((res) => {
              var { data } = res;
              if (data && data.StatusCode == 200) {
                vm.DeleteConfirm = false;
                vm.CancelComments = "";
                vm.success_message = "Transaction Deleted";
                setTimeout(function () {
                  vm.success_message = null;
                  vm.CloseModal();
                }, 1500);
              } else if (data && data.StatusCode == 450) {
                var { ResponseData } = data;
                if (ResponseData) {
                  for (var prop in ResponseData) {
                    vm.$validator.errors.add({
                      field: prop,
                      msg: ResponseData[prop],
                    });
                  }
                }
              } else if (
                data &&
                (data.StatusCode == 500 ||
                  data.StatusCode == 403 ||
                  data.StatusCode == 2 ||
                  data.StatusCode == 429 ||
                  data.StatusCode == 1 ||
                  data.StatusCode == 406 ||
                  data.StatusCode == 0)
              ) {
              } else {
                vm.DeleteConfirm = false;
                vm.CancelComments = "";
                console.log(res);
              }
            })
            .catch((err) => {
              vm.DeleteConfirm = false;
              vm.CancelComments = "";
              console.log(err);
            });
        }
      });
    },
  },
  beforeMount() {
    if (this.RequestId != 0 && this.RequestId != null) {
      this.getData();
    }
  },
  mounted() {
    //Clear Error is there is any.
    this.$store.commit(ACTIONS.DOWNLOAD_DOCUMENT_SUCCESS);
  },
  computed: {
    ...mapGetters({
      Request: "GETBUYREQUEST",
      errorMessage: "GETBUYREQUESTSAVEERROR",
      loading: "GETBUYREQUESTSAVELOADING",
      Downloading: "DOCSLOADING",
      DownloadingErrorMessage: "DOCSERRORMESSAGE",
      RoleId: "RoleId",
      CONFIRMLOADING: "GETCONFIRMLOADING",
      CONFIRMERROR: "GETCONFIRMERROR",
    //  PHYSICALDELIVERY_LOADING:"GETPHYSICALDELIVERYLOADING",
      //PHYSICALDELIVERY_ERROR:"GETPHYSICALDELIVERYERROR"
    }),
  },
};
</script>
